import type { Item } from '@libs/analytics';
import type { BuyItAgainItem } from '@libs/common-types';

import { resolvePrice } from './resolve-price';

export type ViewItemListAttribution = {
    itemListName: string;
    itemListId: string;
};

/**
 * Maps Buy It Again recommendations into `view_item_list` items using the PLP item shape.
 * `index` is the 1-based carousel position; page-level fields and `item_search_term` are set
 * by the impression hook that consumes these items.
 */
export const mapBuyItAgainViewItems = (
    products: BuyItAgainItem[],
    { itemListName, itemListId }: ViewItemListAttribution
): Item[] =>
    products.map((product, index) => ({
        item_name: product.name,
        item_id: product.webStyleId,
        price: resolvePrice(product.price),
        index: index + 1,
        item_category: product.itemCategory ?? '',
        item_category2: product.itemCategory2 ?? '',
        item_category3: product.itemCategory3 ?? '',
        item_category4: product.itemCategory4 ?? '',
        item_category5: product.itemCategory5 ?? '',
        item_brand: product.brand,
        item_variant: product.sku,
        item_list_name: itemListName,
        item_list_id: itemListId,
    }));
